import {
  BoxIcon,
  CropIcon,
  CrosshairIcon,
  FlameIcon,
  LayersIcon,
  PaletteIcon,
  PrinterIcon,
  Rotate3dIcon,
  Rows3Icon,
  ScissorsIcon,
  SquareDashedIcon,
  SunIcon,
} from "lucide-react"

// Keyed by the same names the icon's `name` prop takes: pdfview action names
// (BLEED, VIEW_3D) and imposition destination names (PRINT, PANTONE, ...)
// alike — `ToggleButton` falls back to `SquareDashedIcon` for anything
// unlisted.
export const TOGGLE_BUTTON_ICONS = {
  BLEED: CropIcon,
  DIE_CUT: ScissorsIcon,
  HOT_FOIL: FlameIcon,
  LAMINATION: LayersIcon,
  MARKS: CrosshairIcon,
  PANTONE: PaletteIcon,
  PRINT: PrinterIcon,
  SCREEN_PRINT: LayersIcon,
  UV: SunIcon,
  VIEW_3D: BoxIcon,
  VIEW_FREE: Rotate3dIcon,
  VIEW_STRIPE: Rows3Icon,
} as const

export const DEFAULT_TOGGLE_BUTTON_ICON = SquareDashedIcon
